<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">


        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6
                    class="card-title mb-0 float-start"
                    style="padding-left: 25px"
                  >
                    {{ $t("roleAdd") }}
                  </h6>
                  <button
                    class="btn btn-default btn-sm float-end"
                    @click="resetForm"
                    type="button"
                  >
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button>
                </div>
                <div class="card-body">
             

                  <form
                    class="forms-sample"
                    @submit.prevent="submitData"
                    method="POST"
                  >

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("roleNameTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          :placeholder="$t('roleNameTxt')"
                          v-model="forms.name"
                          required
                        />
                        <div v-if="errors.name">
                          <div
                            v-for="error in errors.name"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row mb-3">
                      <div class="col-lg-2">
                        <label
                          for="defaultconfig"
                          class="col-form-label"
                          style="padding-left: 25px"
                          >{{ $t("descriptionTxt") }}</label
                        >
                      </div>
                      <div class="col-lg-8">
                        <input
                          type="text"
                          class="form-control"
                          id="description"
                          :placeholder="$t('descriptionTxt')"
                          v-model="forms.description"
                        />
                        <div v-if="errors.description">
                          <div
                            v-for="error in errors.description"
                            :key="error"
                            class="alert alert-primary"
                            role="alert"
                          >
                            <i data-feather="alert-circle"></i>
                            {{ error }}
                          </div>
                        </div>
                      </div>
                    </div>
                    
 

                    <div class="row card">
                      <div class="card-header">
                        <h5 class="float-start">
                          Permission <span class="wajib">*</span>
                        </h5>

                        <button
                          class="
                            btn btn-success btn-icon
                            text-white
                            fw-bolder
                            btn-icon-text
                            float-end
                          "
                          @click="addField()"
                          type="button"
                        >
                          <i class="link-icon" data-feather="plus"></i>
                        </button>
                      </div>

                      <div class="card-body">
                        <div class="table-responsive">
                          <table
                            class="table table-hover"
                            style="height: 300px"
                          >
                            <thead>
                              <tr>
                                <th>#</th>
                                <th width="300px">Permission</th>
                                <th>Create</th>
                                <th>Read</th>
                                <th>Update</th>
                                <th>Delete</th>
                                <th>Upload</th>
                                <th>custom1</th>
                                <th>custom2</th>
                                <th>custom3</th>
                                <th>custom4</th>
                                <th>custom5</th>

                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(input, index) in this.detailAll"
                                :key="`phoneInput-${index}`"
                              >
                                <th>{{ index + 1 }}</th>
                                <td width="200px">
                                  <v-select
                                    :options="fetchPermission"
                                    v-model="input.permission"
                                    label="controller"
                                    return-object
                                    @search="asyncSearchPermission"
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_create"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_read"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_update"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_delete"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_upload"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_custom1"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_custom2"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_custom3"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_custom4"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td width="200px">
                                  <v-select
                                    :options="fetchOptionSelect"
                                    v-model="input.method_custom5"
                                    label="name"
                                    return-object
                                  ></v-select>
                                </td>

                                <td>
                                  <!--          Remove Svg Icon-->
                                  <svg
                                    @click="removeField(index, detailAll)"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="24"
                                    height="24"
                                    class="ml-2 cursor-pointer"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path
                                      fill="red"
                                      d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
                                    />
                                  </svg>

                                  <a
                                    href="#"
                                    title="Check All"
                                    v-if="!(input.method_read?.id == 1 && input.method_create?.id == 1 && input.method_update?.id == 1  && input.method_upload?.id == 1  && input.method_delete?.id == 1  && input.method_custom1?.id == 1  && input.method_custom2?.id == 1  && input.method_custom3?.id == 1  && input.method_custom4?.id == 1  && input.method_custom5?.id == 1 )"
                                    @click.prevent="
                                      checkAll(index, detailAll)
                                    "
                                  >
                                      <i class="mdi mdi-check-circle-outline" style="font-size:24px"></i> 
                                  </a>

                                    <a
                                    href="#"
                                    title="unCheck All"
                                    v-else
                                    @click.prevent="
                                      unCheckAll(index, detailAll)
                                    "
                                  >
                                      <i class="mdi mdi-circle-off-outline" style="font-size:24px"></i> 
                                  </a>
                                </td>
                              </tr>
                            </tbody>

                            <tfoot></tfoot>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div class="card-footer">
                      <button
                        class="
                          btn btn-warning
                          text-black
                          fw-bolder
                          btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                      >
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>

                      &nbsp;&nbsp;&nbsp;
                      <button
                        class="btn btn-primary float-end btn-sm"
                        type="submit"
                      >
                        <i class="link-icon" data-feather="save"></i>
                        {{ $t("submitFormTxt") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!--end::card-->
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>


<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
 
export default {
  name: "RoleAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      permision_role: [],
      fetchPermission: [],
      fetchOptionSelect: [
        {
          id: 1,
          name: "Yes",
        },
        {
          id: 0,
          name: "No",
        },
      ],
      permission: [],
      userData: "",
      companyCode: "",
      forms: {},
      detailAll: [],
    };
  },
  watch: {},
  methods: {
    resetForm() {
      this.forms.name = "";
      this.forms.description = "";
    },
    checkAll(index,detail){
      detail[index].method_create = { id: 1,name: "Yes"};
      detail[index].method_read = { id: 1,name: "Yes"};
      detail[index].method_update = { id: 1,name: "Yes"};
      detail[index].method_delete = { id: 1,name: "Yes"};
      detail[index].method_upload = { id: 1,name: "Yes"};
      detail[index].method_custom1 = { id: 1,name: "Yes"};
      detail[index].method_custom2 = { id: 1,name: "Yes"};
      detail[index].method_custom3 = { id: 1,name: "Yes"};
      detail[index].method_custom4 = { id: 1,name: "Yes"};
      detail[index].method_custom5 = { id: 1,name: "Yes"};
    },
     unCheckAll(index,detail){
      detail[index].method_create = {id: 0, name: "No"};
      detail[index].method_read = {id: 0, name: "No"};
      detail[index].method_update = {id: 0, name: "No"};
      detail[index].method_delete = {id: 0, name: "No"};
      detail[index].method_upload = {id: 0, name: "No"};
      detail[index].method_custom1 = {id: 0, name: "No"};
      detail[index].method_custom2 = {id: 0, name: "No"};
      detail[index].method_custom3 = {id: 0, name: "No"};
      detail[index].method_custom4 = {id: 0, name: "No"};
      detail[index].method_custom5 = {id: 0, name: "No"};
    },
    backForm() {
      window.location.href = "/role";
    },

    addField() {
      //fieldType.push({ value: "" });
      this.detailAll.push({
        permission: "",
        method_create: "",
        method_read: "",
        method_update: "",
        method_delete: "",
        method_upload: "",
        method_custom1: "",
        method_custom2: "",
        method_custom3: "",
        method_custom4: "",
        method_custom5: "",
      });
    },

    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },

        logout(){

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
                
            console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

    submitData() {
      this.fade(true);
 
      let sendPermission = [];

      if(this.detailAll.length > 0){

        this.detailAll.forEach((item) => {
        const data = {
          permission_id: item.permission.permission_id,
          method_create: item.method_create.id,
          method_read: item.method_read.id,
          method_update: item.method_update.id,
          method_delete: item.method_delete.id,
          method_upload: item.method_upload.id,
          method_custom1: item.method_custom1.id,
          method_custom2: item.method_custom2.id,
          method_custom3: item.method_custom3.id,
          method_custom4: item.method_custom4.id,
          method_custom5: item.method_custom5.id,
        };
          sendPermission.push(data);
        });

      }
       
      this.forms.permission_role = sendPermission;

      const baseURI = this.$settings.endPoint + "role/create";
      this.$http
        .post(baseURI, this.forms,{ timeout: 10000 })
        .then((response) => {
          this.loading();
          if (response.data.status === 200) {
            this.errors = [];

            var params = this.$onRandom(response.data.datas.role_id);
            window.location.href ="/role/detail/" + params + "?status=200&msg=Successfully";
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
        })
        .catch((error) => {
          this.loading();
          if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
          }else{
            if (error.response) {
              if(error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
              }else if (error.response.status === 401) {
                  this.logout();
              } else if (error.response.status === 403) {
                  this.$router.push("/authorized-error");
              }else if (error.response.status === 500) {
                  this.$router.push('/server-error');
              }else{
                  this.$router.push('/page-not-found');
              }
            }

          }
        });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },
 

    loadPermission() {
      const baseURI = this.$settings.endPoint + `permission`;

      return this.$http.get(baseURI).then((response) => {
        this.fetchPermission = response.data.datas.data;
      });
    },

    asyncSearchPermission(ev) {
      const baseURI = this.$settings.endPoint + `permission?controller=` + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchPermission = response.data.datas.data;
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission !== null && permision.permission.controller == "RoleController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_create) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },
 

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },
 
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  computed: {
 
    likesSomeTypeTruck() {
      return this.truck_type.length > 0 && !this.likesAllTypeTruck;
    },
    icon() {
      if (this.likesAllTypeTruck) return "mdi-close-box";
      if (this.likesSomeTypeTruck) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadPermission();
  },
};
</script>
<style scoped>
</style>